module.exports = __webpack_public_path__ + "img/banner-1-m.282369fc.jpg";